module.exports = __webpack_public_path__ + "img/heroimage.8a28e9aa.png";